import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {BsPersonFill} from "react-icons/bs";
import {formatHM} from "../../helpers/time";
import {memberLimit} from "../../helpers/memberLimit";
import {useGroupManager} from "../../Providers/groupManager";
import {groupPhotoUrl} from "../../helpers/avatar";
import GroupAvatar from "../GroupAvatar";
import {Container, AvatarWrap, Avatar, Body, Name, Members, UnreadBadge, TopRow, Time, Preview} from "./styles";

// Rótulo do grupo: usa o nome; se vazio, cai no gid sem o sufixo "@g.us".
export const groupLabel = (group) => group.name || (group.gid ? group.gid.split("@")[0] : "");

const initials = (text) =>
    text.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "#";

// Cor do avatar derivada do id do grupo — puramente visual e determinística (não é dado real).
const AVATAR_COLORS = ["#2F80ED", "#8B5CF6", "#8A94A6", "#2BC0AD", "#EC4899"];
const avatarColor = (group) => AVATAR_COLORS[Number(group.id || 0) % AVATAR_COLORS.length];

/**
 * Uma linha da lista de grupos: avatar (iniciais), nome, prévia da última mensagem
 * (You:/Sender: texto) + horário, nº de membros e badge de não-lidas.
 */
const GroupListItem = ({group, active, unreadCount = 0, onClick}) => {
    const {t} = useTranslation();
    const {campaign, membersCountByGroup} = useGroupManager();
    const name = groupLabel(group);
    const hasLast = !!group.last_message_at;
    const senderPrefix = group.last_message_from_me
        ? `${t("words.you")}: `
        : (group.last_message_sender ? `${group.last_message_sender}: ` : "");

    return (
        <Container $active={active} onClick={() => onClick(group)}>
            <AvatarWrap>
                <Avatar $color={avatarColor(group)}><GroupAvatar name={name} photoUrl={groupPhotoUrl(campaign)}/></Avatar>
            </AvatarWrap>

            <Body>
                <TopRow>
                    <Name>{name}</Name>
                    {hasLast && <Time data-testid="last-time">{formatHM(group.last_message_at)}</Time>}
                </TopRow>
                <Preview>
                    {hasLast ? `${senderPrefix}${group.last_message_content || ""}` : t("words.no_messages")}
                </Preview>
                <Members>
                    <BsPersonFill/> {membersCountByGroup?.[group.id] ?? group.members_count} / {memberLimit(campaign)} {t("words.subscribers")}
                </Members>
            </Body>

            {unreadCount > 0 && <UnreadBadge>{unreadCount}</UnreadBadge>}
        </Container>
    );
};

GroupListItem.propTypes = {
    group: PropTypes.object.isRequired,
    active: PropTypes.bool,
    unreadCount: PropTypes.number,
    onClick: PropTypes.func.isRequired,
};

export default GroupListItem;
